import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { LabTestApi } from '../api/labtest.api';
import { switchMap, map } from 'rxjs/operators';

import { LabResultData, LabResult } from '../../../interfaces/lab/lab-result-detail' ;
import { LabResultApi } from '../api/labresultdetail.api';
@Injectable()
export class LabResultService extends LabResultData {

    constructor(private api: LabResultApi) {
      super();
    }
  
  
    list(url: string): Observable<any[]> {
      return this.api.list(url);
    }

    targetList(url: string,regId:string,tenantId:string,branchId:string): Observable<any[]> {
      return this.api.targetList(url,regId,tenantId,branchId);
    }
    reportList(url: string,data:any): Observable<any> {
      return this.api.reportList(url,data);
    }
  
    getById(url:string): Observable<any>{
        return this.api.getById(url);
    }
  
    create(url: string, data:LabResult[]): Observable<LabResult[]> {
      return this.api.add(url,data);
    }
    createLabMaster(url: string, data:any): Observable<any> {
      return this.api.add(url,data);
    }
    updateLabMaster(url: string, data:any): Observable<any> {
      return this.api.updateLabMaster(url,data);
    }
  
    update(url: string, data:LabResult): Observable<LabResult[]> {
      return this.api.update(url,data);
    }
  
    
  
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }
  }
  